<template>

<div class="modal-info">
    <div class="user-profile ccbs" v-if="this.MeusInvestimentosAll != null && this.MeusInvestimentosAll.length > 0">
        <div class="row">
            <div class="col-12 tit_page">
                <div class="float-left">
                    <h1>Minhas CCB's</h1>
                </div>
                <div class="back float-right text-right">
                    <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> <span>Voltar</span>
                    </a>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="row">
            <div class="col-12">
                <div v-if="pcScreen" class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th scope="col" class="align-middle">&nbsp;&nbsp;ID</th>
                                <th scope="col" class="align-middle">Empresa</th>
                                <th scope="col">CNPJ</th>
                                <th scope="col">Valor investido</th>
                                <th scope="col">Prazo</th>
                                <th scope="col">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sol in MeusInvestimentosAll" v-bind:key="sol._id">
                                <th scope="row" class="align-middle">
                                    <router-link :to='"/investimentos/historico/historico-de-investimento/" + sol._id ' class="btn btn-link">
                                        #{{ajustIdOportunidade(sol.SolicitacaoId.IdOportunidade,5)}}
                                    </router-link>
                                </th>
                                <td class="align-middle">{{ ObterNome(sol.SolicitacaoId)}}</td>
                                <td class="align-middle">{{formattedCnpj(sol.SolicitacaoId.Documento)}}</td>
                                <td class="align-middle">R$ {{formatCurrency(sol.Valor)}}</td>
                                <td class="align-middle">{{sol.SolicitacaoId.Prazo}} Meses</td>
                                <td v-if="sol.AssinouCCB == true">
                                    <a :href='CCB_URL+"/imprimirccb.aspx?code="+sol.CodigoBMP+"&copias=1"' target="_blank" class="btn btn-secondary btn-block">Visualizar
                                    </a>
                                </td>

                                <td v-if="sol.AssinouCCB != true">
                                    <router-link :to='"/investimentos/minhas-ccbs/formalizar/" + sol._id ' class="btn btn-primary btn-block">Assinar
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="margin">
                    <div class="col-12 mb-3" v-for="item in MeusInvestimentosAll" v-bind:key="item.id">
                        <div :class="'card rounded shadow status-' + Status(item.AssinouCCB)">
                            <div class="card-header d-flex justify-content-between">
                                <span>ID: <strong>#{{ajustIdOportunidade(item.SolicitacaoId.IdOportunidade,5)}}</strong></span>
                            </div>
                            <div class="card-body rounded bg-white">
                                <div class="row no-gutters align-items-center">
                                    <div class="card-info">
                                        <h4>{{ ObterNome(item.SolicitacaoId)}}</h4>
                                        <span>CNPJ: <strong>{{formattedCnpj(item.SolicitacaoId.Documento)}}</strong></span>
                                        <span>Valor investido: <strong>R$ {{formatCurrency(item.Valor)}}</strong></span>
                                        <span>Prazo: <strong>{{item.SolicitacaoId.Prazo}}</strong></span>
                                    </div>
                                </div>
                                <hr class="divider">
                                <div class="row no-gutters">
                                    <div class="col-12">
                                        <router-link v-if="item.AssinouCCB" :to='"/investimentos/minhas-ccbs/formalizar/" + item._id '
                                            class="btn btn-sm btn-primary btn-block font-weight-bold text-uppercase status-deactivate">Visualizar CCB</router-link>
                                        <router-link v-if="!item.AssinouCCB" :to='"/investimentos/minhas-ccbs/formalizar/" + item._id '
                                            class="btn btn-sm btn-primary btn-block font-weight-bold text-uppercase">Assinar</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="MeusInvestimentosAll == null || MeusInvestimentosAll.length == 0" class="d-flex justify-content-center align-items-center dashboard">
        <div class="dashboard__complete">
            <div class="row">
                <div class="col-12 text-center">
                    <h1>Minhas CCB's</h1>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Masker from '@/utils/masker'
  import ApiClient from '../utils/api-client'
  
  import * as mutationTypes from "@/store/mutation-types.js";
    export default {

         data() {
            return {
                CCB_URL:process.env.CCB_URL,
                MeusInvestimentosAll:[],
                terminou : false,
            }
         },
        computed:{
            pcScreen(){
                return (window.innerWidth >1050)
            }
        },
         methods:{
            Status(status){
                return status ? "deactivate" :"active"
            },
            VerificaAssintatura(sol){
                
              return sol.AssinouCCB == true ? "secondary" : "primary";
            },

             LinkCCB(sol){
               
              return sol.AssinouCCB == true ? process.env.CCB_URL+"/imprimirccb.aspx?code="+sol.CodigoBMP+"&copias=1" : "/investimentos/minhas-ccbs/formalizar/"+sol._id;
            },

            
            formatCurrency(value) {
                if(value != null)
                return value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2})

                return 0;
            },
            formattedCnpj(documento) {
                return Masker.maskCnpj(documento)
            },
             ObterNome(solicitacao){


                if(solicitacao.Empresa != null && solicitacao.Empresa.NomeFantasia != "")
                        return solicitacao.Empresa.NomeFantasia;

                if(solicitacao.Impacto != null && solicitacao.Impacto.NomeFantasia != "")
                        return solicitacao.Impact.NomeFantasia;

                if(solicitacao.Social != null && solicitacao.Social.RazaoSocial != "")
                        return solicitacao.Social.RazaoSocial;
                
                if(solicitacao.Social != null && solicitacao.Social.NomeCompleto != "")
                        return solicitacao.Social.NomeCompleto;

            },
            ajustIdOportunidade(id, qtd) {
				var s = String(id);

				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}

				return s;
            },

            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/minhas-ccbs/',
                    title: 'MinhasCCBS',
                })
            },
         },


        async created() {
            if(window.location.href.indexOf("dashboard-app") != -1) this.moneyp = "digital"
            
            this.$store.commit(mutationTypes.START_LOADING);
            ApiClient.getInfosMyCCBs()
            .then(infos => {
                this.MeusInvestimentosAll = infos.data.filter((item)=>{
                    return (
                        item.SolicitacaoId.StatusAnalise == "ENCERRADO" &&
                        item.SolicitacaoId.CCBsAssinaturas == true
                    )
                });
                this.$store.commit(mutationTypes.STOP_LOADING)
            }).catch(error => {
                console.log('error', error)
                this.$store.commit(mutationTypes.STOP_LOADING)
            })

            //tagueamento GA
            await this.taggingGA()
        }
        
    }
</script>

<style lang="scss" scoped>
    .user-profile {
        .tit_page {
            padding-bottom:0px;
        }
    }
    .table {
        &.t-layout-auto {
            table-layout: auto;
        }
        thead {
            tr {
                th {
                    &:nth-child(1) {
                        width: 8%;
                    }
                    &:nth-child(4) {
                        width: 15%;
                    }
                    &:nth-child(5) {
                        width: 10%;
                    }
                    &:nth-child(6) {
                        width: 12%;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1050px){
        // FONTE
        $basefont: 'Montserrat', sans-serif;
        $fontcontent: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";

        // CORES
        $active : #40CD28;
        $deactivate : #878E96;

        .shadow {
            box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        }

        .status {

            &-active {
                background: $active;
            }

            &-deactivate {
                background: $deactivate;
            }
        }

        .margin {
        margin: 20px 5px;
        }

        .background-card {
            background: #fff;
        }

        .card {
            border: none;

            &-header {
                border-bottom: none;
                padding: 5px 10px;
                color: #fff;
                font-size: 12px;
            }

            &-body {
                padding: 10px;

                hr {
                    margin-top:10px;
                    margin-bottom:10px;
                }
            } 

            &-info {
                h4 {
                    font-size: 14px;
                    letter-spacing: 0px;
                    padding-bottom: 2px;
                }

                strong {
                    color: #000;
                }

                span {
                    color: #666;
                    font-size: 13px;
                    display: block;
                    line-height: 16px;
                }
            }
        }

        // botões
        .status-active .btn {
            padding-top: 2px;
            padding-bottom: 2px;

            &-primary {
                background: $active;
                border-color: $active;

                &:hover {
                    background: darken($active, 5%);
                    border-color: darken($active, 5%);
                }
            }
        }

        .status-deactivate .btn {
            padding-top: 2px;
            padding-bottom: 2px;

            &-primary {
                background: $deactivate;
                border-color: $deactivate;

                &:hover {
                    background: darken($deactivate, 5%);
                    border-color: darken($deactivate, 5%);
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/CCBList.vue